"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonNetworkService = exports.retry_cliente = void 0;
var common_network_request_1 = require("../class/common-network-request");
var helpers_1 = require("../helpers");
var envConfig_1 = require("../envConfig");
var main_1 = require("../main");
exports.retry_cliente = 1;
var CommonNetworkService = /** @class */ (function () {
    function CommonNetworkService(defaultNetworkConfig) {
        if (defaultNetworkConfig === void 0) { defaultNetworkConfig = {}; }
        this._hostUrl = helpers_1.EnvironmentHelper.isClientSide()
            ? window.location.protocol + "//" + window.location.host
            : "".concat(envConfig_1.COMMON_ENV_CONFIG.HOST_ENDPOINT);
        this.defaultNetworkConfig = defaultNetworkConfig;
    }
    CommonNetworkService.prototype.coreNetworkRequest = function (request) {
        var _this = this;
        return new Promise(function (resolve, rejected) {
            if (exports.retry_cliente > 0 || !request.url.endsWith('/cliente')) {
                fetch(request.url, request.requestOptions)
                    .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (request.url.endsWith('/cliente') && response.status == 500) {
                                    exports.retry_cliente--;
                                }
                                if (!response.ok) return [3 /*break*/, 1];
                                return [2 /*return*/, resolve(request.returnCompleteResponse
                                        ? response
                                        : response.json().catch(function () {
                                            helpers_1.ConsoleHelper.info("Errore in fase di recupero json(), la chiamata può non contenere dati.");
                                            return {};
                                        }))];
                            case 1:
                                if (!this.checkLogoutCondition(request, response)) return [3 /*break*/, 4];
                                helpers_1.ConsoleHelper.info("Cancellazione dati sessione per chiamata con stato ".concat(response.status));
                                return [4 /*yield*/, this.get("/logout", {}, true).catch(function (err) {
                                        return console.error(err);
                                    })];
                            case 2:
                                _a.sent();
                                return [4 /*yield*/, helpers_1.SessionHelper.deleteAllData().catch(function (err) {
                                        return console.error(err);
                                    })];
                            case 3:
                                _a.sent();
                                main_1.Helpers.RouterHelper.goTo("/homepage");
                                _a.label = 4;
                            case 4: return [2 /*return*/, rejected(request.returnCompleteResponse
                                    ? response
                                    : response.json().catch(function () {
                                        helpers_1.ConsoleHelper.info("Errore in fase di recupero json(), la chiamata può non contenere dati.");
                                        return {};
                                    }))];
                        }
                    });
                }); })
                    .catch(function (responseError) {
                    var _a;
                    if (typeof responseError === "object") {
                        responseError["headers"] = (_a = request === null || request === void 0 ? void 0 : request.requestOptions) === null || _a === void 0 ? void 0 : _a.headers;
                    }
                    return rejected(responseError);
                });
            }
            else {
                rejected('Too Many 500 calling /cliente. Blocked');
            }
        });
    };
    CommonNetworkService.prototype.checkLogoutCondition = function (request, response) {
        var URL_NEED_LOGOUT = [
            "contesto-utente/v1/me/infoUtente",
            "contesto-utente/v1/me/account",
            "contesto-utente/v1/me/cliente/anagrafica",
            "contesto-utente/v1/me/utente",
            "contesto-utente/v1/me/cliente",
        ];
        var URL_TO_EXCLUDE = [
            "tpd/telepedaggio-us/vendita/v2/catalogo/widget",
            "telematici/auto",
            "contratti/v1/mieOfferte",
            "/login",
            "preferiti/v1/utente",
            "pagamenti/v2/metodiPagamento",
            "CIE/recupera-informazioni",
            "SPID/recupera-informazioni",
            "pagamenti/v1/acquisti/pagamenti/abilitaUtente"
        ];
        return ((!URL_TO_EXCLUDE.find(function (element) { var _a; return (_a = request === null || request === void 0 ? void 0 : request.url) === null || _a === void 0 ? void 0 : _a.includes(element); }) &&
            (response.status === 401 || response.status === 403)) ||
            (response.status === 403 &&
                URL_NEED_LOGOUT.find(function (element) { var _a; return (_a = request === null || request === void 0 ? void 0 : request.url) === null || _a === void 0 ? void 0 : _a.includes(element); })));
    };
    CommonNetworkService.prototype.getNetworkConfig = function () {
        var _this = this;
        if (Object.keys(this.defaultNetworkConfig).length > 0) {
            return Promise.resolve({
                json: function () { return Promise.resolve(_this.defaultNetworkConfig); },
            });
        }
        else if (helpers_1.EnvironmentHelper.isServerSide()) {
            return Promise.resolve({
                json: function () { return Promise.resolve(envConfig_1.COMMON_ENV_CONFIG.NETWORK_CONFIG); },
            });
        }
        else {
            return helpers_1.SessionHelper.getData("_dk")
                .then(function (configString) {
                if (!configString) {
                    throw new Error("Cannot retrieve _dk from local-storage");
                }
                var config = JSON.parse(configString);
                // there are some cases when config is still a string after a JSON.parse
                if (typeof config === "string") {
                    config = JSON.parse(config);
                }
                return {
                    json: function () { return Promise.resolve(config); },
                };
            })
                .catch(function (e) {
                helpers_1.ConsoleHelper.error("Errore nel recupero del networkConfig da storage: ", e);
                var networkConfigEndpoint = _this.getNetworkConfigEndpoint();
                return fetch(networkConfigEndpoint, {
                    method: "GET",
                })
                    .catch(function (error) {
                    helpers_1.ConsoleHelper.error("[ERROR] networkConfigEndpoint", networkConfigEndpoint);
                    throw new Error(error);
                })
                    .then(function (res) {
                    if (res.ok) {
                        return res.json();
                    }
                    else {
                        return Promise.reject();
                    }
                })
                    .then(function (resJson) {
                    return helpers_1.SessionHelper.setData("_dk", JSON.stringify(resJson))
                        .catch(function () { return null; })
                        .then(function () { return ({
                        json: function () { return Promise.resolve(resJson); },
                    }); });
                });
            });
        }
    };
    CommonNetworkService.prototype.getNetworkConfigEndpoint = function () {
        if (helpers_1.EnvironmentHelper.isLocalEnvironment()) {
            return "http://localhost:3000/api/network-config";
        }
        else if (new RegExp(/axintpd01\.servizi\.gr-u\.it/).test(this._hostUrl) ||
            new RegExp(/axintpd02\.servizi\.gr-u\.it/).test(this._hostUrl)) {
            return "https://sit.unipol.it/web/commons/config/network.config.json";
        }
        else if (helpers_1.UrlHelper.isHCLAuthoringPageUrl(this._hostUrl)) {
            return "".concat(this._hostUrl, "/web/commons/config/network.config.json");
        }
        else {
            return "".concat(this._hostUrl, "/api/network-config");
        }
    };
    CommonNetworkService.prototype.generateRandomRequestId = function () {
        return "2"
            .concat(new Date().getTime().toString())
            .concat(Math.round(Math.random() * 90 + 10).toString());
    };
    CommonNetworkService.prototype.createHeaderAndCallFunction = function (header) {
        return __awaiter(this, void 0, void 0, function () {
            var networkConfig, networkConfigResponse, e_1, completeHeader, impersonificazione, jsonObject;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getNetworkConfig()];
                    case 1:
                        networkConfigResponse = _a.sent();
                        return [4 /*yield*/, networkConfigResponse.json()];
                    case 2:
                        networkConfig = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        helpers_1.ConsoleHelper.error("Errore nel recupero del networkConfig: ", e_1);
                        return [3 /*break*/, 4];
                    case 4:
                        completeHeader = {
                            "Content-Type": "application/json",
                        };
                        if (header && Object.keys(header).length > 0) {
                            // andiamo in aggiunta con le proprietà custom e sovrascriviamo in caso
                            completeHeader = Object.assign(completeHeader, header);
                        }
                        if (networkConfig) {
                            completeHeader["x-ibm-client-id"] = networkConfig.clientId;
                            completeHeader["x-ibm-client-secret"] = networkConfig.clientSecret;
                            completeHeader["x-unipol-requestid"] = this.generateRandomRequestId();
                        }
                        return [4 /*yield*/, helpers_1.SessionHelper.getData("_data5").catch(function () { return null; })];
                    case 5:
                        impersonificazione = _a.sent();
                        if (impersonificazione) {
                            try {
                                jsonObject = JSON.parse(impersonificazione);
                                if (jsonObject.value0 === "0" && jsonObject.value1 !== "") {
                                    completeHeader["x-personification"] = jsonObject.value1;
                                }
                            }
                            catch (error) {
                                helpers_1.ConsoleHelper.error("Errore in fase di recupero dell'impersonificazione: ", { impersonificazione: impersonificazione, error: error });
                            }
                        }
                        return [2 /*return*/, Promise.resolve(completeHeader)];
                }
            });
        });
    };
    CommonNetworkService.prototype.post = function (url, body, header, returnCompleteResponse, enableRequestIdLog) {
        var _this = this;
        if (returnCompleteResponse === void 0) { returnCompleteResponse = false; }
        if (enableRequestIdLog === void 0) { enableRequestIdLog = false; }
        return this.createHeaderAndCallFunction(header).then(function (completeHeader) {
            if (enableRequestIdLog) {
                console.log('[CommonNetworkService - post] - url: ', url, 'requestId: ', completeHeader["x-unipol-requestid"], 'body: ', JSON.stringify(body));
            }
            return _this.coreNetworkRequest(new common_network_request_1.CommonNetworkRequest(url, {
                body: body,
                headers: completeHeader,
                method: "POST",
            }, returnCompleteResponse));
        });
    };
    CommonNetworkService.prototype.get = function (url, header, returnCompleteResponse) {
        var _this = this;
        if (returnCompleteResponse === void 0) { returnCompleteResponse = false; }
        return this.createHeaderAndCallFunction(header).then(function (completeHeader) {
            return _this.coreNetworkRequest(new common_network_request_1.CommonNetworkRequest(url, {
                headers: completeHeader,
                method: "GET",
            }, returnCompleteResponse));
        });
    };
    CommonNetworkService.prototype.delete = function (url, body, header, returnCompleteResponse) {
        var _this = this;
        if (returnCompleteResponse === void 0) { returnCompleteResponse = false; }
        return this.createHeaderAndCallFunction(header).then(function (completeHeader) {
            return _this.coreNetworkRequest(new common_network_request_1.CommonNetworkRequest(url, {
                body: body,
                headers: completeHeader,
                method: "DELETE",
            }, returnCompleteResponse));
        });
    };
    CommonNetworkService.prototype.put = function (url, body, header, returnCompleteResponse) {
        var _this = this;
        if (returnCompleteResponse === void 0) { returnCompleteResponse = false; }
        return this.createHeaderAndCallFunction(header).then(function (completeHeader) {
            return _this.coreNetworkRequest(new common_network_request_1.CommonNetworkRequest(url, {
                body: body,
                headers: completeHeader,
                method: "PUT",
            }, returnCompleteResponse));
        });
    };
    CommonNetworkService.prototype.patch = function (url, body, header, returnCompleteResponse) {
        var _this = this;
        if (returnCompleteResponse === void 0) { returnCompleteResponse = false; }
        return this.createHeaderAndCallFunction(header).then(function (completeHeader) {
            return _this.coreNetworkRequest(new common_network_request_1.CommonNetworkRequest(url, {
                body: body,
                headers: completeHeader,
                method: "PATCH",
            }, returnCompleteResponse));
        });
    };
    return CommonNetworkService;
}());
exports.CommonNetworkService = CommonNetworkService;
